module.exports = __webpack_public_path__ + "img/Icon_Info_gray.10246ebe.svg";